// PhotoCarousel.js
import { useState, useEffect } from 'react';
import { NextBtnIcon, PrevBtnIcon } from '../Utils/Icons';

const PhotoCarousel = ({ photos }) => {
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

    const handleNextPhoto = () => {
        setCurrentPhotoIndex((prevIndex) => (prevIndex + 1) % photos.length);
    };

    const handlePrevPhoto = () => {
        setCurrentPhotoIndex((prevIndex) =>
            prevIndex === 0 ? photos.length - 1 : prevIndex - 1
        );
    };

    useEffect(() => {
        const interval = setInterval(handleNextPhoto, 5000);
        return () => clearInterval(interval);
    }, [photos]);

    return (
        photos.length > 0 && (
            <div className="image-wrapper">
                <img src={photos[currentPhotoIndex]} alt="Auction Item" />
                <div className="imageBtns">
                    <button className="prev-button" onClick={handlePrevPhoto}>
                        <PrevBtnIcon />
                    </button>
                    <button className="next-button" onClick={handleNextPhoto}>
                        <NextBtnIcon />
                    </button>
                </div>
            </div>
        )
    );
};

export default PhotoCarousel;